import styled from 'styled-components'

import { theme } from '@dasa-health/components-react'

export const StoriesContainer = styled.div`
    z-index: 1;
    position: relative;

    & > div > div:first-child {
        left: 0;
        top: 0;
        width: 100% !important;
        padding: 7px 1.1% 5px !important;

        & > div {
            background-color: rgba(255, 255, 255, 0.4) !important;
        }
    }
`

export const Container = styled.div`
    background-color: ${theme.colors.primary} !important;
    width: 100%;
    height: 100%;
    padding: 40px 16px;

    @media screen and (min-width: ${theme.breakpoints[0]}) {
        // tablet
        padding-left: 110px;
        padding-right: 110px;
    }

    > div {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;

        @media (min-width: ${theme.breakpoints[0]}) and (max-width: ${theme.breakpoints[2]}) {
            // tablet
            max-height: 80%;
        }
    }
`

export const Content = styled.main`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    width: 100%;
    padding: 0;
    margin: 0;

    > img {
        @media (min-width: ${theme.breakpoints[0]}) {
            // tablet
            width: 200px;
            height: auto;
        }
    }

    > h1 {
        color: ${theme.colors.white};
        font-size: 1.75em;
        font-family: ${theme.fonts.normal};
        margin-top: 52px;
        margin-bottom: 8px;
        text-align: center;
        line-height: 40px;
        font-weight: bold;
        max-width: 250px;

        @media (min-width: ${theme.breakpoints[0]}) {
            // tablet
            font-size: 2em;
            text-align: center;
            margin-bottom: 16px;
        }
    }

    > p {
        text-align: center;
        font-size: 1em;
        line-height: 24px;

        @media (min-width: ${theme.breakpoints[0]}) {
            // tablet
            max-width: 360px;
            text-align: center;
        }
    }
`
